module.exports = __webpack_public_path__ + "img/fruit-clementines-190x100.bdaa99b8.jpg";